import { AfterViewInit, Component, inject } from "@angular/core";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";

@Component({
    selector: 'webhook-popup',
    templateUrl: './webhook-edit-confirm-popup.component.html',
    standalone: false,
})

export class WebHookConfirmPopupComponent implements AfterViewInit {

    data = inject(NZ_MODAL_DATA);
    modalRef = inject(NzModalRef);

    constructor() {
        // Initialization logic can go here
    }

    

    ngAfterViewInit(): void {
        // Logic to execute after the view has been initialized
        console.log('Webhook Edit Confirm Popup Initialized');
    }

}


